import { Draw } from '@slot-nx/core'
import { Container, Graphics } from '@pixi/react'
import { ReactElement, useCallback } from 'react'

export const GrayBackground = (props: {
  children?: ReactElement
  name?: string
  isChangePose?: boolean
  width: number
  height: number
}) => {
  const draw = useCallback<Draw>((graphics) => {
    graphics.clear()
    graphics.beginFill(0x000000, 1)
    graphics.drawRect(0, 0, props.width, props.height)
    graphics.endFill()
  }, [props.height, props.width])

  return (
    <Container
      name={props.name ? props.name : 'GrayBackground'}
      x={0}
      y={0}
      width={props.width}
      height={props.height}
    >
      <Graphics
        name="gray overlay background"
        width={props.width}
        height={props.height}
        draw={draw}
        eventMode="static"
      />
      {props.children}
    </Container>
  )
}
